export const qk = {
  me: ['me'],
  employees: (filters = {}) => ['employees', filters],
  employee: (id) => ['employee', id],
  departments: ['departments'],
  designations: ['designations'],
  payGrades: ['payGrades'],
  holidays: ['holidays'],
  leaveTypes: ['leaveTypes'],
  salaryComponents: ['salaryComponents'],
  attendance: (filters = {}) => ['attendance', filters],
  leaveRequests: (filters = {}) => ['leaveRequests', filters],
  shortLeave: (filters = {}) => ['shortLeave', filters],
  overtime: (filters = {}) => ['overtime', filters],
  loans: (filters = {}) => ['loans', filters],
  advances: (filters = {}) => ['advances', filters],
  salaryHolds: (filters = {}) => ['salaryHolds', filters],
  salaryHold: (id) => ['salaryHold', id],
  payrollRuns: ['payrollRuns'],
  payrollRun: (id) => ['payrollRun', id],
  taxTables: ['taxTables'],
  companySettings: ['companySettings'],
  users: ['users'],
  audit: (filters = {}) => ['audit', filters],
  dashboard: ['dashboard'],
  shifts: ['shifts'],
  employeeCategories: ['employeeCategories'],
  shiftCalendar: (year, month) => ['shiftCalendar', year, month],
  shiftPeriodStatus: (year, month) => ['shiftPeriodStatus', year, month],
};
